import { escapeHtml } from "@/utils/markdown";

/**
 * Text colors offered in the email editor. Kept in sync with EMAIL_TEXT_COLORS
 * in recruit-ai-api/src/utils/richEmailBody.js, which the AI uses.
 */
export const EMAIL_TEXT_COLORS = [
  { name: "Red", value: "#dc2626" },
  { name: "Blue", value: "#1d4ed8" },
  { name: "Green", value: "#15803d" },
] as const;

/** Normalize a CSS color ("#DC2626", "rgb(220, 38, 38)") to lowercase #rrggbb, or "" if unknown. */
export function toHexColor(color: string | null | undefined): string {
  const v = (color || "").trim().toLowerCase();
  if (/^#[0-9a-f]{6}$/.test(v)) return v;
  if (/^#[0-9a-f]{3}$/.test(v)) return `#${[...v.slice(1)].map(c => c + c).join("")}`;
  const m = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})/.exec(v);
  if (m)
    return `#${m
      .slice(1, 4)
      .map(n => Number(n).toString(16).padStart(2, "0"))
      .join("")}`;
  return "";
}

export const PLACEHOLDER_RE = /\{\{[^}]*\}\}/g;

export function findPlaceholders(text: string): string[] {
  return text.match(PLACEHOLDER_RE) || [];
}

export function cleanPlaceholder(ph: string): string {
  return ph.replace(/^\{\{\s*/, "").replace(/\s*\}\}$/, "");
}

/** Legacy plain-text body → paragraph HTML (blank lines split paragraphs, newlines become <br>). */
export function plainTextToHtml(text: string): string {
  return (text || "")
    .replace(/\r\n?/g, "\n")
    .split(/\n{2,}/)
    .map(p => p.trim())
    .filter(Boolean)
    .map(p => `<p>${escapeHtml(p).replace(/\n/g, "<br>")}</p>`)
    .join("");
}

/** The HTML to load into the editor for a draft: the rich body, or the plain body converted. */
export function initialEmailHtml(email: { body: string; richBody?: string | null }): string {
  return email.richBody || plainTextToHtml(email.body);
}
